import { AxiosInstance } from "axios";
import { ApiService } from "../models/Api.model";
import { IPricingCalculatorRequest } from "../interfaces/calculator/IPricingCalculatorRequest";
import { IPricingCalculatorResponse } from "../interfaces/calculator/IPricingCalculatorResponse";
import { IBaseResponse } from './IBaseResponse';
import { IPricingUpdateRequest } from "../interfaces/calculator/ISpecialProjectPricingUpdateRequest";
import { IPrecatorio } from "../interfaces/IPrecatorio";

enum PricingServiceEnum {
  calculatePrice = "/calculate-price",
  updatePricing = "/update-pricing",
  officerUpdatePricing = "/update/price-and-commission",
  updatePrecatorioPricing = "/update/precatorio",
}
export default class PricingService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/pricing");
  }
  
  public calculatePrice = async (request: IPricingCalculatorRequest): Promise<IBaseResponse<IPricingCalculatorResponse>> => await this.POST(PricingServiceEnum.calculatePrice, request);
  public updatePricing = async (request:IPricingUpdateRequest) => await this.PUT(PricingServiceEnum.updatePricing, request);
  public officerUpdatePricing = async (request:IPricingUpdateRequest) => await this.PUT(PricingServiceEnum.officerUpdatePricing, request);
  public updatePrecatorioPricing = async (request: IPrecatorio): Promise<IBaseResponse>  => await this.PUT(PricingServiceEnum.updatePrecatorioPricing, request);
}



// WEBPACK FOOTER //
// ./src/services/api/Pricing.service.ts